import {Component, Input, OnInit} from '@angular/core';
import { LaboratoryDocumentsNamespace } from '@components/laboratory-documents/laboratory-documents.namespace';

@Component({
    selector: 'app-laboratory-document-add-button',
    templateUrl: 'document-add-button.component.html',
    styleUrls: ['document-add-button.component.scss']
})

export class DocumentAddButtonComponent {
    @Input() defaultType: LaboratoryDocumentsNamespace.DocumentTypeEnum;

    /**
     * Куда добавляем документы?
     * В Организацию? В Лабораторию? Добавляем все документы?
     */
    @Input() target: 'all' | 'lab' | 'org' = 'all';
}
